module.exports = __webpack_public_path__ + "static/media/form.eda2891c.png";